<template>
  <div class="p-2">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3"
    >
      <div class="d-flex flex-column justify-content-center">
        <h4 class="mb-1 mt-3">Add A New Course</h4>
        <p class="text-muted">Course placed across your E-store</p>
      </div>
      <div class="d-flex align-content-center flex-wrap gap-3">
        <div class="d-flex gap-3">
          <button class="btn btn-label-secondary waves-effect">Discard</button>
          <button class="btn btn-label-primary waves-effect" @click="saveCourse(false)">
            Save draft
          </button>
        </div>
        <button
          type="submit"
          class="btn btn-primary waves-effect waves-light"
          @click="saveCourse(true)"
        >
          Continue
        </button>
      </div>
    </div>

    <div class="row">
      <!-- First column-->
      <div class="col-12 col-lg-8">
        <!-- Product Information -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="card-tile mb-0">Course information</h5>
          </div>
          <div class="row card-body">
            <div class="col-lg-6 mb-3">
              <label class="form-label" for="ecommerce-product-name">Name</label>
              <input
                type="text"
                class="form-control"
                id="ecommerce-product-name"
                placeholder="Course title"
                name="productTitle"
                v-model="title"
                aria-label="Course title"
              />
            </div>
            <div class="col-lg-6 mb-3">
              <label class="form-label" for="ecommerce-product-sku">Category</label>
              <v-select
                id="user-checkout-state"
                v-model="category"
                placeholder="Category"
                :options="categories"
              />
            </div>
            <!-- Description -->
            <div>
              <label class="form-label">Description (Optional)</label>
              <editor
                v-model="courseDescription"
                :api-key="settingStore.tinymce.api_key"
                :init="settingStore.tinymce.configuration"
              />
            </div>
          </div>
        </div>
        <!-- /Product Information -->
      </div>
      <!-- /Second column -->

      <!-- Second column -->
      <div class="col-12 col-lg-4">
        <!-- Media -->
        <div class="card">
          <div class="border rounded p-2">
            <h4 class="mb-1">Media</h4>
            <div class="media flex-column flex-md-row">
              <img
                :src="educationStore.file"
                id="blog-feature-image preview"
                class="rounded mr-2 mb-1 mb-md-0"
                width="170"
                height="110"
                alt="Blog Featured Image"
                v-if="educationStore.file"
              />
              <img
                src="/assets/images/slider/03.jpg"
                id="blog-feature-image preview"
                class="rounded mr-2 mb-1 mb-md-0"
                width="170"
                height="110"
                alt="Blog Featured Image"
                v-else
              />

              <div class="media-body">
                <small class="text-muted"
                  >Required image resolution 800x400, image size 10mb.</small
                >
                <p class="my-50">
                  <a href="javascript:void(0);" id="blog-image-text"
                    >C:\fakepath\banner.jpg</a
                  >
                </p>
                <div class="d-inline-block">
                  <div class="form-group mb-0">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="blogCustomFile"
                        accept="image/*"
                        data-toggle="modal"
                        data-target="#larger"
                        @change="selectedImg"
                        enctype="multipart/form-data"
                      />
                      <label class="custom-file-label" for="blogCustomFile"
                        >Choose file</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">Author</h5>
          </div>
          <div class="card-body">
            <!-- Base Price -->
            <div class="">
              <label class="form-label" for="ecommerce-product-price">Created By</label>
              <input
                v-model="educationStore.author"
                type="author"
                class="form-control"
                id="author"
                placeholder="author"
                name="author"
                aria-label="author"
              />
            </div>
          </div>
        </div>
        <!-- add skill level -->
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">Skill Level</h5>
          </div>
          <div class="card-body">
            <!-- Base Price -->
            <div class="">
              <label class="form-label" for="ecommerce-product-price">Skill Level</label>
              <v-select
                id="ecommerce-product-price"
                v-model="skill_level"
                placeholder="Skill Level"
                :options="skill_levels"
              />
            </div>
          </div>
        </div>
        <!-- End of skill level -->
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">Pre-Sell Option</h5>
          </div>
          <div class="card-body">
            <!-- Base Price -->
            <div class="mt-1">
              <label class="form-label" for="ecommerce-product-price">Pre-Sell</label>
              <v-select
                id="ecommerce-product-price"
                v-model="pre_sell"
                placeholder="Pre-Sell"
                :options="pre_sells"
              />
            </div>
            <div class="mb-1 mt-1">
              <label for="dob">Pre-sell End Date</label>
              <flat-pickr
                v-model="pre_sell_end_date"
                :config="userStore.config"
                class="form-control"
              ></flat-pickr>
            </div>

            <div class="mt-1">
              <label class="form-label" for="pre-sell-price">pre-sell price</label>
              <input
                v-model="pre_sell_price"
                type="number"
                class="form-control"
                id="pre-sell-price"
                placeholder="Price"
                name="productPrice"
                aria-label="Product price"
              />
            </div>
            <div class="mb-1 mt-1">
              <label class="form-label" for="pre-sell-price">After pre-sell price</label>
              <input
                v-model="price"
                type="number"
                class="form-control"
                id="pre-sell-price"
                placeholder="Price"
                name="productPrice"
                aria-label="Product price"
              />
            </div>
          </div>
        </div>
        <!-- Pricing Card -->
        <div class="card" v-if="!pre_sell">
          <div class="card-header">
            <h5 class="card-title mb-0">Pricing</h5>
          </div>
          <div class="card-body">
            <!-- Base Price -->
            <div class="mb-3">
              <label class="form-label" for="ecommerce-product-price">Free</label>
              <v-select
                id="ecommerce-product-price"
                v-model="is_free"
                placeholder="Free"
                :options="actions"
              />
            </div>
            <div class="mb-1" v-if="!is_free">
              <label class="form-label" for="ecommerce-product-price">Base Price</label>
              <input
                v-model="price"
                type="number"
                class="form-control"
                id="ecommerce-product-price"
                placeholder="Price"
                name="productPrice"
                aria-label="Product price"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <image-cropper-modal></image-cropper-modal>
  <!-- skill level
        Basic
        Intermediate
        Expert
    -->
</template>
<script>
import { ref, reactive } from "vue";
import { useSettingStore } from "../../../../stores/SettingStore.js";
import { useEducationStore } from "../../../../stores/EducationStore.js";
import { useUserStore } from "../../../../stores/UserStore.js";
import Editor from "@tinymce/tinymce-vue";
import vSelect from "vue-select";
import { Cropper } from "vue-advanced-cropper";
import { closeModal, openModal, nowDate } from "../../../../utilities/_helpers";
import flatPickr from "vue-flatpickr-component";
import Select2 from "vue3-select2-component";
import "flatpickr/dist/flatpickr.css";
import "vue-advanced-cropper/dist/style.css";
import "vue-select/dist/vue-select.css";
export default {
  components: {
    Editor,
    vSelect,
    Cropper,
    flatPickr,
    Select2,
  },
  setup(props) {
    return {
      title: ref(),
      is_free: ref(false),
      price: ref(),
      actions: ref([true, false]),
      file: ref(),
      courseDescription: ref(),
      settingStore: useSettingStore(),
      educationStore: useEducationStore(),
      userStore: useUserStore(),
      category: ref(),
      pre_sell: ref(false),
      pre_sells: ref([true, false]),
      pre_sell_price: ref(0.0),
      pre_sell_end_date: nowDate(),
      categories: ref([
        "Credit",
        "Credit Repair",
        "Financial Literacy",
        "Credit Cards",
        "Business Credit",
        "Loans",
        "Travel Hacking",
      ]),
      skill_level: ref(null),
      skill_levels: ref(["Basic", "Intermediate", "Expert"]),
      closeModal: closeModal,
      openModal: openModal,
      nowDate: nowDate,
    };
  },
  mounted() {},
  methods: {
    selectedImg(e) {
      e.preventDefault();
      const file = e.target.files[0];
      this.educationStore.originImage = file;
      this.educationStore.img = URL.createObjectURL(file);
      this.openModal("#imageCropper");
    },
    saveCourse(publish) {
      let $this = this,
        route = this.$router.resolve({
          name: "courses-create",
        });

      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("category", this.category);
      formData.append("description", this.courseDescription);
      formData.append("skill_level", this.skill_level);
      formData.append("price", this.is_free ? 0.0 : this.price);
      formData.append("is_free", this.is_free);
      formData.append("is_presell", this.pre_sell);
      formData.append("presell_price", this.pre_sell_price);
      formData.append("presell_expire_at", this.pre_sell_end_date);
      formData.append("instructor_name", this.educationStore.author);
      formData.append("published", publish);
      formData.append("coverImage", this.educationStore.file);
      axios
        .post(route.href, formData)
        .then(({ data }) => {
          if (data.error != true) {
            $this.$router.push({
              name: "lesson-create",
              params: {
                course: data.data.slug,
              },
            });
            return toastr.success(`${data.message}`, "Create Success");
          } else {
            return toastr.error(`${data.message}`, "Create Error");
          }
        })
        .catch((error) => {
          let errors = $this.getError(error);
          for (const key in errors) {
            if (Object.hasOwnProperty.call(errors, key)) {
              const element = errors[key];
              return toastr.error(`${element}`, "Delete Error");
            }
          }
        });
    },
    getError(error) {
      const errorMsg = "";
      if (!error.response) {
        return errorMsg;
      }
      if (error.response.data && error.response.data.errors) {
        return error.response.data.errors;
      }
      return errorMsg;
    },
  },
};
</script>
<style></style>
